import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IServerDetailModel } from '@apps-common/types/management/server-details'

export const QUERY_KEY_MANAGEMENT_GET_SERVER_DETAILS = () => ['getServerDetails'].filter(Boolean)

export const getServerDetails = async (): Promise<IServerDetailModel[]> =>
  axios.get('/management/UnitProgramTask/ServerDetails').then((res) => res.data?.data)

type QueryFnType = typeof getServerDetails

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useManagementGetServerDetails = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_GET_SERVER_DETAILS(),
    queryFn: () => getServerDetails()
  })
